module.exports = __webpack_public_path__ + "static/media/13.979be921.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/13.png
// module id = 1451
// module chunks = 0